import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useVerifyOTP() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { send, isConnected, isOpen, connect, registerHandler } = useWebSocketContext();
  const mountedRef = useRef(true);
  const connectionAttemptedRef = useRef(false);

  const verifyOTP = useCallback(async ({ email, otp }) => {
    if (!mountedRef.current) return;
   email = localStorage.getItem("forgot_password_email");
    setIsLoading(true);
    setError('');
    setSuccess(false);

    try {
      // Ensure WebSocket is connected
      if (!isConnected) {
        if (!connectionAttemptedRef.current) {
          connectionAttemptedRef.current = true;
          await connect();
        }

        await new Promise((resolve, reject) => {
          const start = Date.now();
          const interval = setInterval(() => {
            if (!mountedRef.current) {
              clearInterval(interval);
              reject(new Error('Component unmounted'));
            } else if (isOpen()) {
              clearInterval(interval);
              resolve(true);
            } else if (Date.now() - start > 10000) {
              clearInterval(interval);
              reject(new Error('Connection timeout'));
            }
          }, 100);
        });
      }

      // Send verify OTP request
      const response = await send("cms_verify_email_otp_cms_user", { email, otp });
      console.log("Verify OTP response:", response);

      if (!response || response.type !== "cms_verify_email_otp_cms_user_response") {
        throw new Error("Invalid response from server");
      }

      if (!response.success) {
        throw new Error(response.message || "OTP verification failed");
      }

      setSuccess(true);
      return { success: true };
    } catch (err) {
      setError(err.message);
      setSuccess(false);
      return { success: false, error: err.message };
    } finally {
      if (mountedRef.current) setIsLoading(false);
    }
  }, [isConnected, isOpen, connect, send]);

  // Example server push handler
  useEffect(() => {
    const unregister = registerHandler("verify_otp_update", (msg) => {
      if (mountedRef.current) {
        console.log("Verify OTP update:", msg);
      }
    });
    return () => unregister();
  }, [registerHandler]);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false };
  }, []);

  return { isLoading, error, success, verifyOTP };
}
